import styles from './styles.module.scss';

interface SentBy {
  name: string;
  avatar?: string;
  title?: string;
}

type TestimonialProps = {
  sent_by: SentBy;
  rating: number;
  text: string;
};

const TestimonialModal = ({ sent_by, rating, text }: TestimonialProps) => {
  return (
    <div className={styles.modalContent}>
      <div className={styles.header}>
        <img
          src={
            sent_by?.avatar ||
            'https://amityonline.com/_s/avatar_nerd_man_vector_42477860_removebg_preview_68cec19df4.png'
          }
          alt={sent_by?.name}
          className={styles.avatar}
        />
        <div className={styles.meta}>
          <div className={styles.name}>{sent_by?.name}</div>
          {sent_by?.title && <div className={styles.title}>{sent_by?.title}</div>}
        </div>
      </div>

      <div className={styles.stars}>
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i}>{i < rating ? '★' : '☆'}</span>
        ))}
      </div>

      <div className={styles.textContainer}>
        <p className={styles.text}>{text}</p>
      </div>
    </div>
  );
};

export default TestimonialModal;
